import UpdateNotifications from './UpdateNotifications';
export default UpdateNotifications;
